import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { TrackedLink as Link } from 'components/common/TrackedLink';
import { CEB_COLOR } from 'app-constants/CEB_COLOR';
import styled from 'styled-components';
import { Snippet } from '__generated__/graphql';

export interface ResultTitleProps {
  children?: ReactNode;
  url?: string;
}

export const ResultTitle = ({ children, url }: ResultTitleProps) => {
  const location = useLocation();
  return (
    <StyledResultTitle>
      {url ? (
        <Link
          to={url}
          state={{
            from: location,
          }}
        >
          {children}
        </Link>
      ) : (
        children
      )}
    </StyledResultTitle>
  );
};

export const StyledResultTitle = styled.h3`
  font-size: 18px;
  margin-bottom: 10px;
`;

export interface ResultSnippetsProps {
  snippets: Snippet[];
}

export const ResultSnippets = ({ snippets }: ResultSnippetsProps) => (
  <StyledResultSnippets>
    {snippets.map((snippet, i) => {
      return (
        <span
          key={i}
          dangerouslySetInnerHTML={{
            __html: snippet.text + (i < snippets.length - 1 ? ' ... ' : ''),
          }}
        />
      );
    })}
  </StyledResultSnippets>
);

const StyledResultSnippets = styled.span`
  span {
    display: inline;
    font-size: 14px;
    line-height: 1.8;
    a,
    a:visited {
      color: inherit;
      &:hover {
        text-decoration: underline;
      }
    }
    b {
      font-weight: inherit;
      background-color: ${CEB_COLOR('CITRINE_WHITE')};
    }
  }
`;
